"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyRoutes = void 0;
var CurrencyRoutes;
(function (CurrencyRoutes) {
    CurrencyRoutes["BasePrefix"] = "currencies";
    CurrencyRoutes["ById"] = ":currencyId";
    CurrencyRoutes["All"] = "all";
    CurrencyRoutes["List"] = "list";
})(CurrencyRoutes = exports.CurrencyRoutes || (exports.CurrencyRoutes = {}));
